import router from './router';
import store from './store';
const whiteNameList = ['Login'];
router.beforeEach(async (to, from, next) => {
    if (whiteNameList.includes(to.name)) {
        next();
    }
    else if (store.getters.isAuth) {
        next();
    }
    else {
        //   await store.dispatch('auth/refreshToken')
        store.commit('auth/CLEAR');
        next(`/login?redirect=${to.path}`);
    }
});
